import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';

export const EdvironMode = {
	PRODUCTION: 'production',
	DEV: 'development',
} as const;

interface CollectNowProps {
	school_id: string;
	student_id: string;
	mode?: keyof typeof EdvironMode;
	onClose?: () => void;
}

const EdvironOverlay: React.FC<CollectNowProps> = ({ school_id, student_id, mode = 'PRODUCTION', onClose }) => {
	if (!school_id || !student_id) {
		alert('No data provided.');
		return null;
	}

	const prefix = mode === 'PRODUCTION' ? 'pg' : 'dev.pg';
	const initialUrl = `https://${prefix}.edviron.com/collect-fee-initiate?student_id=${student_id}&school_id=${school_id}`;

	return (
		<div
			onClick={onClose}
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100%',
				height: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: 'rgba(0, 0, 0, 0.7)',
				zIndex: 9999,
			}}
		>
			<iframe
				src={initialUrl}
				title='Edviron Payment'
				style={{
					border: 'none',
					borderRadius: '12px',
					width: '75vw',
					height: '88%',
				}}
				onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside iframe
			/>
		</div>
	);
};

export class Edviron {
	private mode: keyof typeof EdvironMode;

	constructor(mode?: keyof typeof EdvironMode) {
		this.mode = mode || 'PRODUCTION';
	}

	collect_now({ school_id, student_id }: { school_id: string; student_id: string }) {
		const container = document.createElement('div');
		document.body.appendChild(container);

		const root = ReactDOM.createRoot(container);

		const handleClose = () => {
			root.unmount();
			container.remove();
		};

		root.render(
			<React.StrictMode>
				<EdvironOverlay school_id={school_id} student_id={student_id} mode={this.mode} onClose={handleClose} />
			</React.StrictMode>,
		);
	}
}
